import EventBus from '@vertx/eventbus-bridge-client.js';

const eventBus = new EventBus(window.VCSTATE.PUSH_GATEWAY_EVENT_BUS_URL);
eventBus.enableReconnect(true);

let eventBusPromise;

const createEventBusPromise = (handlers = {}) => {
  eventBusPromise = new Promise((resolve) => {
    eventBus.onopen = () => {
      Object.entries(handlers).forEach(([address, addressHandlers]) => {
        addressHandlers.forEach((handler) => {
          eventBus.registerHandler(address, handler);
        });
      });

      resolve(eventBus);
    };
  });
};

eventBus.onclose = () => {
  createEventBusPromise(eventBus.handlers);
};

createEventBusPromise();

export default (method) => (...args) => {
  eventBusPromise.then(() => { eventBus[method](...args); });
};
